export default __webpack_public_path__ + "static/media/house-12.3d40540c.jpg";